
// let hosturl = "https://live.youinsh.com/livestreamapi/v1" //请求公共参数 正式

// https://live.youinsh.com/saastestapi/v1/course/network_time/
// let hosturl = "https://live.youinsh.com/saastestapi/v1" //请求公共参数 测试
let hosturl = "https://live.youinsh.com/livestream/v1" //请求公共参数 生产环境



// let hosturlJson = "https://qncdn.youinsh.cn/saastest" //请求json数据 测试
let hosturlJson = "https://qncdn.youinsh.cn/saas_pro" //请求json数据 生产环境

export default {
    state:{
        baseUri:  hosturl,
        baseurlJson: hosturlJson
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/global.js